import { Portfolio } from './portfolio';

export const portfolio: Portfolio[] = [
    {
        "route":  "portrait",
        "header":  "Portrait",
        "items":  [
                      {
                          "small":  {
                                        "src":  "/photos/1_Portrait/small/1%20(1).jpg",
                                        "w":  800,
                                        "h":  572
                                    },
                          "medium":  {
                                         "src":  "/photos/1_Portrait/medium/1%20(1).jpg",
                                         "w":  2000,
                                         "h":  1429
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/1_Portrait/small/1%20(10).jpg",
                                        "w":  533,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/1_Portrait/medium/1%20(10).jpg",
                                         "w":  1333,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/1_Portrait/small/1%20(12).jpg",
                                        "w":  533,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/1_Portrait/medium/1%20(12).jpg",
                                         "w":  1333,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/1_Portrait/small/1%20(14).jpg",
                                        "w":  533,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/1_Portrait/medium/1%20(14).jpg",
                                         "w":  1333,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/1_Portrait/small/1%20(15).jpg",
                                        "w":  534,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/1_Portrait/medium/1%20(15).jpg",
                                         "w":  1334,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/1_Portrait/small/1%20(16).jpg",
                                        "w":  533,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/1_Portrait/medium/1%20(16).jpg",
                                         "w":  1333,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/1_Portrait/small/1%20(19).jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/1_Portrait/medium/1%20(19).jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/1_Portrait/small/1%20(2).jpg",
                                        "w":  571,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/1_Portrait/medium/1%20(2).jpg",
                                         "w":  1428,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/1_Portrait/small/1%20(20).jpg",
                                        "w":  800,
                                        "h":  533
                                    },
                          "medium":  {
                                         "src":  "/photos/1_Portrait/medium/1%20(20).jpg",
                                         "w":  2000,
                                         "h":  1333
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/1_Portrait/small/1%20(21).jpg",
                                        "w":  534,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/1_Portrait/medium/1%20(21).jpg",
                                         "w":  1335,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/1_Portrait/small/1%20(22).jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/1_Portrait/medium/1%20(22).jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/1_Portrait/small/1%20(25).jpg",
                                        "w":  534,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/1_Portrait/medium/1%20(25).jpg",
                                         "w":  1335,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/1_Portrait/small/1%20(26).jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/1_Portrait/medium/1%20(26).jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/1_Portrait/small/1%20(28).jpg",
                                        "w":  534,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/1_Portrait/medium/1%20(28).jpg",
                                         "w":  1335,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/1_Portrait/small/1%20(30).jpg",
                                        "w":  618,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/1_Portrait/medium/1%20(30).jpg",
                                         "w":  1546,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/1_Portrait/small/1%20(33).jpg",
                                        "w":  534,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/1_Portrait/medium/1%20(33).jpg",
                                         "w":  1335,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/1_Portrait/small/1%20(34).jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/1_Portrait/medium/1%20(34).jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/1_Portrait/small/1%20(35).jpg",
                                        "w":  534,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/1_Portrait/medium/1%20(35).jpg",
                                         "w":  1335,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/1_Portrait/small/1%20(4).jpg",
                                        "w":  533,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/1_Portrait/medium/1%20(4).jpg",
                                         "w":  1333,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/1_Portrait/small/1%20(5).jpg",
                                        "w":  571,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/1_Portrait/medium/1%20(5).jpg",
                                         "w":  1429,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/1_Portrait/small/1%20(6).jpg",
                                        "w":  571,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/1_Portrait/medium/1%20(6).jpg",
                                         "w":  1428,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/1_Portrait/small/1%20(7).jpg",
                                        "w":  571,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/1_Portrait/medium/1%20(7).jpg",
                                         "w":  1429,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/1_Portrait/small/1%20(8).jpg",
                                        "w":  533,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/1_Portrait/medium/1%20(8).jpg",
                                         "w":  1333,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/1_Portrait/small/CA1_1301%2B-2.jpg",
                                        "w":  800,
                                        "h":  571
                                    },
                          "medium":  {
                                         "src":  "/photos/1_Portrait/medium/CA1_1301%2B-2.jpg",
                                         "w":  2000,
                                         "h":  1428
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/1_Portrait/small/CA1_1450%2B%2B-3.jpg",
                                        "w":  573,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/1_Portrait/medium/CA1_1450%2B%2B-3.jpg",
                                         "w":  1434,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/1_Portrait/small/CA1_8296%2Bk.jpg",
                                        "w":  571,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/1_Portrait/medium/CA1_8296%2Bk.jpg",
                                         "w":  1428,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/1_Portrait/small/CA1_8400%2Bk.jpg",
                                        "w":  640,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/1_Portrait/medium/CA1_8400%2Bk.jpg",
                                         "w":  1600,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/1_Portrait/small/CA1_8446.jpg",
                                        "w":  571,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/1_Portrait/medium/CA1_8446.jpg",
                                         "w":  1429,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/1_Portrait/small/CA1_8585.jpg",
                                        "w":  572,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/1_Portrait/medium/CA1_8585.jpg",
                                         "w":  1429,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/1_Portrait/small/CA1_8753.jpg",
                                        "w":  533,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/1_Portrait/medium/CA1_8753.jpg",
                                         "w":  1333,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/1_Portrait/small/CA2_6266-2.jpg",
                                        "w":  534,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/1_Portrait/medium/CA2_6266-2.jpg",
                                         "w":  1335,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/1_Portrait/small/CA2_6273.jpg",
                                        "w":  534,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/1_Portrait/medium/CA2_6273.jpg",
                                         "w":  1335,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/1_Portrait/small/CA2_6460.jpg",
                                        "w":  534,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/1_Portrait/medium/CA2_6460.jpg",
                                         "w":  1335,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/1_Portrait/small/DSC_2846%2B.jpg",
                                        "w":  2681,
                                        "h":  3753
                                    },
                          "medium":  {
                                         "src":  "/photos/1_Portrait/medium/DSC_2846%2B.jpg",
                                         "w":  1429,
                                         "h":  2000
                                     }
                      }
                  ]
    },
    {
        "route":  "hochzeit",
        "header":  "Hochzeit",
        "items":  [
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/1%20(14).jpg",
                                        "w":  533,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/1%20(14).jpg",
                                         "w":  1333,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/1%20(2).jpg",
                                        "w":  800,
                                        "h":  533
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/1%20(2).jpg",
                                         "w":  2000,
                                         "h":  1333
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/1%20(23).jpg",
                                        "w":  533,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/1%20(23).jpg",
                                         "w":  1333,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/1%20(29).jpg",
                                        "w":  800,
                                        "h":  571
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/1%20(29).jpg",
                                         "w":  2000,
                                         "h":  1429
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/1%20(30).jpg",
                                        "w":  533,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/1%20(30).jpg",
                                         "w":  1333,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/1%20(41).jpg",
                                        "w":  533,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/1%20(41).jpg",
                                         "w":  1333,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/1%20(48).jpg",
                                        "w":  533,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/1%20(48).jpg",
                                         "w":  1333,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/1%20(49).jpg",
                                        "w":  533,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/1%20(49).jpg",
                                         "w":  1333,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/1%20(53).jpg",
                                        "w":  571,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/1%20(53).jpg",
                                         "w":  1428,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/1%20(64).jpg",
                                        "w":  800,
                                        "h":  533
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/1%20(64).jpg",
                                         "w":  2000,
                                         "h":  1333
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/1%20(71).jpg",
                                        "w":  800,
                                        "h":  571
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/1%20(71).jpg",
                                         "w":  2000,
                                         "h":  1428
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/1%20(77).jpg",
                                        "w":  533,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/1%20(77).jpg",
                                         "w":  1333,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/5%20(16).jpg",
                                        "w":  800,
                                        "h":  533
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/5%20(16).jpg",
                                         "w":  2000,
                                         "h":  1333
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/a1%20(127).jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/a1%20(127).jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/a1%20(16).jpg",
                                        "w":  533,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/a1%20(16).jpg",
                                         "w":  1333,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/a1%20(20).jpg",
                                        "w":  800,
                                        "h":  533
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/a1%20(20).jpg",
                                         "w":  2000,
                                         "h":  1333
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/a1%20(27).jpg",
                                        "w":  800,
                                        "h":  533
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/a1%20(27).jpg",
                                         "w":  2000,
                                         "h":  1333
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/a1%20(5).jpg",
                                        "w":  533,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/a1%20(5).jpg",
                                         "w":  1333,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/a1%20(58).jpg",
                                        "w":  533,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/a1%20(58).jpg",
                                         "w":  1333,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/a1%20(60).jpg",
                                        "w":  533,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/a1%20(60).jpg",
                                         "w":  1333,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/a1%20(70).jpg",
                                        "w":  533,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/a1%20(70).jpg",
                                         "w":  1333,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/a1%20(84).jpg",
                                        "w":  533,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/a1%20(84).jpg",
                                         "w":  1333,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/a1%20(98).jpg",
                                        "w":  533,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/a1%20(98).jpg",
                                         "w":  1333,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/CA1_9317.jpg",
                                        "w":  800,
                                        "h":  571
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/CA1_9317.jpg",
                                         "w":  2000,
                                         "h":  1428
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/CA1_9569.jpg",
                                        "w":  533,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/CA1_9569.jpg",
                                         "w":  1333,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/CA1_9785-2.jpg",
                                        "w":  533,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/CA1_9785-2.jpg",
                                         "w":  1333,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/CA1_9852.jpg",
                                        "w":  800,
                                        "h":  533
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/CA1_9852.jpg",
                                         "w":  2000,
                                         "h":  1333
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/DSC_3040-2.jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/DSC_3040-2.jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/DSC_3174.jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/DSC_3174.jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/p%20(1).jpg",
                                        "w":  800,
                                        "h":  533
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/p%20(1).jpg",
                                         "w":  2000,
                                         "h":  1333
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/p%20(10).jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/p%20(10).jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/p%20(12).jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/p%20(12).jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/p%20(13).jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/p%20(13).jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/p%20(14).jpg",
                                        "w":  534,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/p%20(14).jpg",
                                         "w":  1335,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/p%20(2).jpg",
                                        "w":  533,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/p%20(2).jpg",
                                         "w":  1333,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/p%20(3).jpg",
                                        "w":  533,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/p%20(3).jpg",
                                         "w":  1333,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/p%20(4).jpg",
                                        "w":  533,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/p%20(4).jpg",
                                         "w":  1333,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/p%20(5).jpg",
                                        "w":  800,
                                        "h":  533
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/p%20(5).jpg",
                                         "w":  2000,
                                         "h":  1333
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/p%20(6).jpg",
                                        "w":  533,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/p%20(6).jpg",
                                         "w":  1333,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/p%20(7).jpg",
                                        "w":  800,
                                        "h":  533
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/p%20(7).jpg",
                                         "w":  2000,
                                         "h":  1333
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/p%20(8).jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/p%20(8).jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/2_Hochzeit/small/p%20(9).jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/2_Hochzeit/medium/p%20(9).jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      }
                  ]
    },
    {
        "route":  "event",
        "header":  "Event",
        "items":  [
                      {
                          "small":  {
                                        "src":  "/photos/3_Event/small/a-126.jpg",
                                        "w":  534,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/3_Event/medium/a-126.jpg",
                                         "w":  1335,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/3_Event/small/a-128.jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/3_Event/medium/a-128.jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/3_Event/small/a-172.jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/3_Event/medium/a-172.jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/3_Event/small/a-205.jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/3_Event/medium/a-205.jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/3_Event/small/a-206.jpg",
                                        "w":  534,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/3_Event/medium/a-206.jpg",
                                         "w":  1335,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/3_Event/small/a-276.jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/3_Event/medium/a-276.jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/3_Event/small/a-28.jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/3_Event/medium/a-28.jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/3_Event/small/a-282.jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/3_Event/medium/a-282.jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/3_Event/small/a-292.jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/3_Event/medium/a-292.jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/3_Event/small/a-3.jpg",
                                        "w":  800,
                                        "h":  571
                                    },
                          "medium":  {
                                         "src":  "/photos/3_Event/medium/a-3.jpg",
                                         "w":  2000,
                                         "h":  1428
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/3_Event/small/a-32.jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/3_Event/medium/a-32.jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/3_Event/small/a-40.jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/3_Event/medium/a-40.jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/3_Event/small/CA2_0554.jpg",
                                        "w":  534,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/3_Event/medium/CA2_0554.jpg",
                                         "w":  1335,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/3_Event/small/CA2_0853.jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/3_Event/medium/CA2_0853.jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      }
                  ]
    },
    {
        "route":  "familie",
        "header":  "Familie",
        "items":  [
                      {
                          "small":  {
                                        "src":  "/photos/5_Familie/small/01%20(10).jpg",
                                        "w":  533,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/5_Familie/medium/01%20(10).jpg",
                                         "w":  1333,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/5_Familie/small/01%20(18).jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/5_Familie/medium/01%20(18).jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/5_Familie/small/01%20(19).jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/5_Familie/medium/01%20(19).jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/5_Familie/small/01%20(2).jpg",
                                        "w":  533,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/5_Familie/medium/01%20(2).jpg",
                                         "w":  1333,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/5_Familie/small/01%20(3).jpg",
                                        "w":  800,
                                        "h":  571
                                    },
                          "medium":  {
                                         "src":  "/photos/5_Familie/medium/01%20(3).jpg",
                                         "w":  2000,
                                         "h":  1429
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/5_Familie/small/01%20(30).jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/5_Familie/medium/01%20(30).jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/5_Familie/small/01%20(35).jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/5_Familie/medium/01%20(35).jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/5_Familie/small/01%20(37).jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/5_Familie/medium/01%20(37).jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/5_Familie/small/01%20(4).jpg",
                                        "w":  533,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/5_Familie/medium/01%20(4).jpg",
                                         "w":  1333,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/5_Familie/small/01%20(41).jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/5_Familie/medium/01%20(41).jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/5_Familie/small/01%20(7).jpg",
                                        "w":  533,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/5_Familie/medium/01%20(7).jpg",
                                         "w":  1333,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/5_Familie/small/CA1_1561%2B.jpg",
                                        "w":  572,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/5_Familie/medium/CA1_1561%2B.jpg",
                                         "w":  1429,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/5_Familie/small/CA1_1571%2B.jpg",
                                        "w":  533,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/5_Familie/medium/CA1_1571%2B.jpg",
                                         "w":  1333,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/5_Familie/small/CA1_1580%2B2.jpg",
                                        "w":  800,
                                        "h":  573
                                    },
                          "medium":  {
                                         "src":  "/photos/5_Familie/medium/CA1_1580%2B2.jpg",
                                         "w":  2000,
                                         "h":  1433
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/5_Familie/small/DSC_4761.jpg",
                                        "w":  800,
                                        "h":  571
                                    },
                          "medium":  {
                                         "src":  "/photos/5_Familie/medium/DSC_4761.jpg",
                                         "w":  2000,
                                         "h":  1429
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/5_Familie/small/DSC_4837.jpg",
                                        "w":  571,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/5_Familie/medium/DSC_4837.jpg",
                                         "w":  1429,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/5_Familie/small/DSC_4931.jpg",
                                        "w":  533,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/5_Familie/medium/DSC_4931.jpg",
                                         "w":  1333,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/5_Familie/small/DSC_4932-2.jpg",
                                        "w":  571,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/5_Familie/medium/DSC_4932-2.jpg",
                                         "w":  1428,
                                         "h":  2000
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/5_Familie/small/DSC_5093.jpg",
                                        "w":  534,
                                        "h":  800
                                    },
                          "medium":  {
                                         "src":  "/photos/5_Familie/medium/DSC_5093.jpg",
                                         "w":  1335,
                                         "h":  2000
                                     }
                      }
                  ]
    },
    {
        "route":  "landscape",
        "header":  "Landscape",
        "items":  [
                      {
                          "small":  {
                                        "src":  "/photos/6_Landscape/small/CA1_3166.jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/6_Landscape/medium/CA1_3166.jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/6_Landscape/small/CA2_3999.jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/6_Landscape/medium/CA2_3999.jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/6_Landscape/small/CA2_4031.jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/6_Landscape/medium/CA2_4031.jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/6_Landscape/small/CA2_5093.jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/6_Landscape/medium/CA2_5093.jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/6_Landscape/small/CA2_5154.jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/6_Landscape/medium/CA2_5154.jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/6_Landscape/small/CA2_5630.jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/6_Landscape/medium/CA2_5630.jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/6_Landscape/small/CA2_7967.jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/6_Landscape/medium/CA2_7967.jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/6_Landscape/small/CA2_8042.jpg",
                                        "w":  800,
                                        "h":  533
                                    },
                          "medium":  {
                                         "src":  "/photos/6_Landscape/medium/CA2_8042.jpg",
                                         "w":  2000,
                                         "h":  1333
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/6_Landscape/small/DSC_0183.jpg",
                                        "w":  800,
                                        "h":  534
                                    },
                          "medium":  {
                                         "src":  "/photos/6_Landscape/medium/DSC_0183.jpg",
                                         "w":  2000,
                                         "h":  1335
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/6_Landscape/small/DSC_3063.jpg",
                                        "w":  800,
                                        "h":  531
                                    },
                          "medium":  {
                                         "src":  "/photos/6_Landscape/medium/DSC_3063.jpg",
                                         "w":  2000,
                                         "h":  1328
                                     }
                      },
                      {
                          "small":  {
                                        "src":  "/photos/6_Landscape/small/DSC_3490.jpg",
                                        "w":  800,
                                        "h":  531
                                    },
                          "medium":  {
                                         "src":  "/photos/6_Landscape/medium/DSC_3490.jpg",
                                         "w":  2000,
                                         "h":  1328
                                     }
                      }
                  ]
    }
]
export default portfolio;
